<template>
  <div id="app">
    <b-container fluid class="px-0">
      <div class="body-content">
        <Header></Header>
        <div style="margin-top: 47px">
          <router-view />
        </div>
        <!-- <div
          class="sticky-mandat"
          v-if="$store.getters.current_warrant !== null"
        >
          <b-button-group>
            <b-button
              @click="sticky_mandat_open = !sticky_mandat_open"
              variant="secondary"
              >Mandat {{ $store.getters.current_warrant }}</b-button
            >
            <b-button :to="{ name: 'warrantView', params: {id: $store.getters.current_warrant} }">
              <i class="fad fa-arrow-right"></i>
            </b-button>
          </b-button-group>

          <b-card
            v-if="sticky_mandat_open"
            class="mb-2 shadow sticky-mandat-card"
            header="Résumé"
            header-text-variant="light"
            header-tag="h6"
            bg-variant="secondary"
          >
            <warrant-summary
              :id="$store.getters.current_warrant" :details="true"
            ></warrant-summary>
          </b-card>
        </div> -->
      </div>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
//import WarrantSummary from "@/components/WarrantSummary";
export default {
  name: "App",
  props: ["keycloak"],
  components: {
    Header,
    /* WarrantSummary , */
  },
  data() {
    return {
      sticky_mandat_open: false,
    };
  },
  created() {
    var viewport = document.querySelector("meta[name=viewport]");
    viewport.setAttribute("content", 'width=1920');
    this.$store.commit("loadUser", this.keycloak);
    if (this.$store.getters.isClient) {
      window.location.assign("https://client.v3.recuperator.cabinetdegreft.be");
    }
    this.$store.dispatch("loadCurrentUser", this.keycloak);
  },
};
</script>

<style lang="scss" >
.body-content {
  min-height: calc(100vh - 360px);
}
.sticky-mandat {
  position: fixed;
  top: 63px;
  right: 15px;
  z-index: 1500;
  .btn-group {
    float: right;
  }
  .sticky-mandat-card {
    background-color: var(--light);
    clear: both;
  }
}
</style>
